import { BiDialog, BiTypography, BiButtonGroup, BiButton } from 'bi-web-components-react';
import { signIn } from '../../api';
import useRedirectLoading from '../../hooks/useRedirectLoading';
import { useTranslation } from 'react-i18next';
import { useCartContext } from '../../context/CartContext';

export default function GlobalCartError() {
    const { globalCartError } = useCartContext();
    const { redirectLoading, startRedirectLoading } = useRedirectLoading();
    const { t } = useTranslation(['cart', 'common']);

    const login = async () => {
        startRedirectLoading();
        await signIn();
    };

    if (!globalCartError) {
        return null;
    }

    return (
        <BiDialog isOpen={!!globalCartError} disableBackdropClick>
            <BiTypography fontStyle='bold' fontSize='xl'>
                {t('cart:errorDuringSignInTitle')}
            </BiTypography>
            <br />
            <BiTypography>{t('cart:errorDuringSignInBody')}</BiTypography>

            <BiButtonGroup alignment='right' top='large'>
                <BiButton variant='text' href='/api/cart/logout'>
                    {t('common:cancel')}
                </BiButton>
                <BiButton submitting={redirectLoading} onClick={login}>
                    {t('cart:loginAgain')}
                </BiButton>
            </BiButtonGroup>
        </BiDialog>
    );
}
